/**
 * Regra de disposicao da lista de tomadores.
 *
 * Sao muitos dados por tomador, e eles nao cabem lado a lado em nenhuma tela comum:
 * rolar para o lado esconde o que importa, e quem le uma lista nao rola para o lado.
 * Por isso a lista se reorganiza pela largura que recebeu, e o zoom e o menu lateral
 * aberto ou recolhido nao pedem tratamento proprio. O nome e o dado que nao pode sumir:
 * cada disposicao existe para manter a coluna do nome legivel.
 *
 *   - `ampla`: cada celula mostra um par de dados, com documento e bloqueio em colunas
 *     proprias.
 *   - `reunida`: o documento sobe para a coluna do nome e o bloqueio para a do contato.
 *
 * Em todas, as acoes sao icones com o nome na dica (`AcaoComIcone`).
 *   - `estreita`: o contato e o bloqueio tambem vao para a coluna do nome, em uma
 *     terceira linha.
 *   - `cartoes`: sem largura para colunas, cada tomador vira um cartao.
 *
 * A regra fica em funcao pura porque o ambiente de teste nao calcula layout.
 */

/** A partir desta largura o nome ainda cabe com o documento e o bloqueio em colunas proprias. */
export const LARGURA_DA_LISTA_AMPLA = 1480;

/** Abaixo desta largura o contato ocuparia o lugar do nome. */
export const LARGURA_DA_LISTA_REUNIDA = 920;

/** Abaixo desta largura a coluna do nome ficaria estreita demais para ler. */
export const LARGURA_DA_LISTA_ESTREITA = 700;

export type EncaixeDaLista = 'ampla' | 'reunida' | 'estreita' | 'cartoes';

export function encaixarLista(disponivel: number): EncaixeDaLista {
  // Antes da primeira medida nao ha largura: nada indica que falta espaco.
  if (disponivel <= 0 || disponivel >= LARGURA_DA_LISTA_AMPLA) return 'ampla';
  if (disponivel >= LARGURA_DA_LISTA_REUNIDA) return 'reunida';
  return disponivel >= LARGURA_DA_LISTA_ESTREITA ? 'estreita' : 'cartoes';
}
